// frontend/src/api/client.js
// Axios instance for Legal CRM
// Mirrors HR system client.js pattern — interceptors handle auth and errors

import axios from 'axios';

export const API_URL = import.meta.env.VITE_API_URL || '/api';

const apiClient = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
});

// ─── Request interceptor — attach token ───────────────────────────────────────

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('legal_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ─── Response interceptor — handle errors globally ────────────────────────────

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response, config } = error;

    // Auth endpoints — let the component handle errors (don't redirect)
    const authEndpoints = [
      '/auth/admin/login',
      '/auth/vendor/login',
      '/auth/partner/login',
      '/auth/vendor/register',
      '/auth/forgot-password',
      '/auth/reset-password',
    ];

    const isAuthEndpoint = authEndpoints.some((endpoint) =>
      config?.url?.includes(endpoint)
    );

    if (isAuthEndpoint) {
      return Promise.reject({
        message: response?.data?.error || response?.data?.message || error.message || 'An error occurred',
        status:  response?.status,
        data:    response?.data,
      });
    }

    // 401 on protected routes — clear session and redirect to login
    if (response?.status === 401) {
      localStorage.removeItem('legal_token');
      localStorage.removeItem('legal_user');
      window.location.href = '/login';
    }

    return Promise.reject({
      message: response?.data?.error || response?.data?.message || error.message || 'An error occurred',
      status:  response?.status,
      data:    response?.data,
    });
  }
);

export default apiClient;
